import React from "react"

const PageSectionsAnchorWrapper = ({ i, children, anchor }) => {
  if (anchor) {
    return (
      <div key={`section-${i}`} id={anchor}>
        {children}
      </div>
    )
  } else {
    return { children }
  }
}

export default PageSectionsAnchorWrapper
